import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--background-dark, #0A0A0A);
  color: var(--text-light, #FFFFFF);
  font-family: 'Montserrat', sans-serif;
  text-align: center;
  padding: var(--spacing-md, 2rem);
`;

const Content = styled.div`
  max-width: 500px;
`;

const ErrorCode = styled.h1`
  font-family: 'Playfair Display', serif;
  font-size: 6rem;
  font-weight: 700;
  color: var(--accent, #D4AF37);
  margin: 0;
  line-height: 1;
`;

const Title = styled.h2`
  font-family: 'Playfair Display', serif;
  font-size: 1.5rem;
  font-weight: 500;
  margin: 1rem 0;
`;

const Description = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 2rem;
`;

const BackButton = styled.button`
  background: var(--accent, #D4AF37);
  color: var(--background-dark, #0A0A0A);
  border: none;
  padding: 0.75rem 2rem;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: var(--border-radius-sm, 4px);
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }
`;

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Container>
      <Content>
        <ErrorCode>404</ErrorCode>
        <Title>Page introuvable</Title>
        <Description>
          La page que vous recherchez n&apos;existe pas ou a été déplacée.
        </Description>
        <BackButton onClick={() => navigate('/')}>
          Retour à l&apos;accueil
        </BackButton>
      </Content>
    </Container>
  );
}
